export enum DisplayMode {
  Fun = "fun",
  Minimal = "minimal",
}
